import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./SelectBaseCourse.module.css";
import PropTypes from 'prop-types';
import { coursesApi, studyGroupsApi } from '../../../../utils'
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { Filter, FilterExtention, FilterItem, FilterTypesEnum, Filters } from "../../../UI/Filter";
import Disciplines from "../../Admin/Disciplines/Disciplines";


const SelectBaseCourse = forwardRef(({ setValid, studyGroup, handleSetStudyGroupId, handleSetStudyGroupName, handleChangeBaseCourseId, courseSelected, setCourseSelected }, ref) => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);
    const applicationId = useSelector(state => state.application.applicationId);
    const [coursesFromAPI, setCoursesFromAPI] = useState([])
    const [filteredList, setFillterdList] = useState()
    const dispatch = useDispatch()

    const sortArray = (type) => {

        if (coursesFromAPI) {
            if (type === "all") {
                setFillterdList(coursesFromAPI)
            }
            else {
                const filtered = coursesFromAPI.filter(c => {
                    return c.lang === type;
                });
                setFillterdList(filtered)
            }
        }
    };

    const selectDisciplineCB = (id) => {
        const selectedCourse = coursesFromAPI.find(course => course.id === id);
        const random = Math.floor(Math.random() * (246)) + 10;
        setCourseSelected({ courseSelectedId: id, courseSelectedName: selectedCourse?.name, courseSelectedColor: `${selectedCourse?.baseColor}${random.toString(16)}` })
    }

    useEffect(() => {
        if (applicationId) {
            async function getCoursesData() {
                const data = {
                    id: null,
                    year: null,
                    lang: null,
                    active: true,
                    domainId: null,
                    applicationId: applicationId,
                    fromClass: null,
                    toClass: null
                }

                coursesApi.coursesFilterRangePost({ coursesRangeFilter: data }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, statusCode: response?.statusCode, message: "coursesFilterRangePost " + error.message, level: 2, component: "SelectBaseCourse", line: 53 }))
                    } else {
                        let sortedBaseCourses = resdata.sort((a, b) => (a.recommendedClass - b.recommendedClass || a.name.localeCompare(b.name)));
                        setCoursesFromAPI(sortedBaseCourses.map(r => {
                            const parse = r.additionalData && JSON.parse(r.additionalData)
                            return { ...r, backgroundImage: parse?.CardBackgroundImage, baseColor: parse?.BaseColor }
                        }))
                        setFillterdList(sortedBaseCourses.map(r => {
                            const parse = r.additionalData && JSON.parse(r.additionalData)
                            return { ...r, backgroundImage: parse?.CardBackgroundImage, baseColor: parse?.BaseColor }
                        }))
                    }
                })
            }
            getCoursesData()
        }

    }, [applicationId])


    useEffect(() => {
        //fetch
        if (courseSelected && courseSelected.courseSelectedId) {
            setValid(true)
            handleChangeBaseCourseId(courseSelected.courseSelectedId, courseSelected.courseSelectedColor)
        } else {
            setValid(false)
        }
    }, [courseSelected, setValid])

    useImperativeHandle(ref, () => ({
        async stepNext() {
            if (studyGroup.id) {
                let data = { studyGroupId: studyGroup.id, courseId: courseSelected.courseSelectedId, name: courseSelected.courseSelectedName, additionalData: `{"color":"${courseSelected.courseSelectedColor}"}` }
                studyGroupsApi.studyGroupsUpdatePost({ studyGroupUpdateInput: data }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.studyGroupsUpdateError, error: error, statusCode: response?.statusCode, message: "studyGroupsUpdatePost " + error.message, level: 2, component: "SelectBaseCourse", line: 88 }))
                    } else {
                        // change name and keep the same id
                        handleSetStudyGroupName(courseSelected.courseSelectedName)
                    }
                })
            } else {
                let data = { courseId: courseSelected.courseSelectedId, name: courseSelected.courseSelectedName, additionalData: `{"color":"${courseSelected.courseSelectedColor}"}` }
                studyGroupsApi.studyGroupsAddPost({ studyGroupAddInput: data }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.studyGroupsAddError, error: error, statusCode: response?.statusCode, message: "studyGroupsAddError " + error.message, level: 2, component: "SelectBaseCourse", line: 98 }))
                    } else {
                        handleSetStudyGroupId(resdata)
                        handleSetStudyGroupName(courseSelected.courseSelectedName)
                    }
                })
            }
        }
    }))

    return (
        <div className={`${classes[direction]}`} >
            <h2 className={classes.Introduction}>{texts.introduction}</h2>
            <div className={`${classes.SortSelectWarrper} ${classes.Introduction}`}>
                <div>{texts.selectBaseCourse}</div>
            </div>
            <div className={classes.CoursesWrapOverflow}>
                <div className={classes.CoursesWrap}>
                    <FilterExtention list={coursesFromAPI}>
                        <Filters >
                            <Filter name="lang" text={texts.filterByLanguage} type={FilterTypesEnum.valuesList} values={{ he: texts.he, ar: texts.ar }}></Filter>
                        </Filters>
                        <FilterItem>
                            <Disciplines courseSelected={courseSelected} selectDisciplineCB={selectDisciplineCB} />
                        </FilterItem>
                    </FilterExtention>
                </div>
            </div>
        </div>)
})

SelectBaseCourse.propTypes = {
    setValid: PropTypes.func
}

export default SelectBaseCourse;